import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';
import SettingsItem from './SettingsItem';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useModal } from 'vibo-ui/Modal';

import { Modals } from 'types/enums';

import useStyles from './style';

const Logout: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { openModal } = useModal();

  const openLogOutModal = useCallback(
    () =>
      openModal({
        key: Modals.logOut,
      }),
    []
  );

  return (
    <SettingsItem>
      <div className={classNames('label', classes.label)}>
        <Icon icon={IconmoonFont['logOut-24']} className={classes.generalIcon} />
        <Button onClick={openLogOutModal} displayType="link">
          {t('logOut')}
        </Button>
      </div>
    </SettingsItem>
  );
};

export default Logout;
